import React, { useContext } from 'react'
import { Button } from 'journey-ui'
import { ItemPageContext } from '../../contexts/ItemPageContext'
import { calculateItemToppingPrice, isIncludedTopping, money, sum } from '../../helpers'

interface Props {
  portionOption: PortionOption
  currentTopping: ItemTopping
}

export const PortionOptionBtn: React.FC<Props> = ({ portionOption, currentTopping }) => {
  const { form, setForm, itemPageJson } = useContext(ItemPageContext)
  const formTopping = form.toppings.find((t) => t.name === currentTopping.name && t.portion_name === portionOption.portion_name)
  const alreadySelected = !!formTopping

  const onPortionClick = () => {
    const newFormTopping: ItemTopping = {
      ...currentTopping,
      hash_id: portionOption.hash_id,
      portion_name: portionOption.portion_name,
    }

    newFormTopping.is_included = isIncludedTopping(newFormTopping, itemPageJson)
    newFormTopping.price = calculateItemToppingPrice(newFormTopping, itemPageJson)
    newFormTopping.price += portionOption.price_difference

    const previousToppingsPrice = sum(form.toppings.map((t) => t.price)) * form.quantity

    const newToppings = form.toppings.map(
      (t) => (t.name === currentTopping.name && t.tile_hash_id === currentTopping.tile_hash_id ? newFormTopping : t),
    )

    const newToppingsPrice = sum(newToppings.map((t) => t.price)) * form.quantity

    setForm({
      ...form,
      price: form.price - previousToppingsPrice + newToppingsPrice,
      toppings: newToppings,
    })
  }

  const priceLabel = (portionOption.price_difference > 0 ? '+' : '') + money(portionOption.price_difference)

  return (
    <Button className="border-none rounded-none space-x-4 justify-between" onClick={() => onPortionClick()}>
      <span>{portionOption.portion_name}</span>
      <span>
        {alreadySelected ? 'Selected' : priceLabel}
      </span>
    </Button>
  )
}
